.deactivateText {
    color: var(--hps-blue);
    padding-bottom: 10px;
}
